import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ITransactionReceiptFeature } from './transaction-receipt.feature.state';
import { TransactionReceiptState } from './transaction-receipt.state';

export const getTransactionReceiptState: MemoizedSelector<ITransactionReceiptFeature, TransactionReceiptState> = createFeatureSelector<
  TransactionReceiptState
>(nameof<ITransactionReceiptFeature>('transactionReceiptFeature'));

export const getIsLoading = createSelector(getTransactionReceiptState, (state: TransactionReceiptState) => state.isLoading);
export const getTransactionReceipt = createSelector(
  getTransactionReceiptState,
  (state: TransactionReceiptState) => state.transactionReceipt
);
